import React from 'react';
import { Icon } from '@iconify/react';
import { HighlightedTextIcon } from 'components/molecules';
import { AboutSectionContentProps } from 'components/organisms/About/types';
import reactIcon from '@iconify/icons-logos/react';
import tailwindcssIcon from '@iconify/icons-logos/tailwindcss-icon';

const Text = () => (
  <>
    I design cutting-edge, full-stack web solutions with  <HighlightedTextIcon
      as="a"
      href="https://reactjs.org"
      className="mx-2"
      icon={<Icon icon={reactIcon} />}
    >
      <span className="font-bold text-gray-800">React</span>
    </HighlightedTextIcon>
    {', '} <HighlightedTextIcon as="a" href="https://www.typescriptlang.org/" className="mx-2" icon={<img src="/img/typescript.svg" alt="TypeScript" className="w-5 h-5" />}>
      <span className="font-bold text-gray-800">TypeScript</span>
    </HighlightedTextIcon>, and <HighlightedTextIcon as="a" href="https://supabase.com/" className="mx-2" icon={<img src="/img/supabase.svg" alt="Supabase" className="w-5 h-5" />}>
      <span className="font-bold text-gray-800">Supabase</span>
    </HighlightedTextIcon>. My specialty is developing responsive user interfaces and solid backends for modern web applications. I enjoy building production-ready web apps using
    <HighlightedTextIcon
      as="a"
      href="https://reactjs.org"
      className="mx-2"
      icon={<Icon icon={reactIcon} />}
    >
      <span className="font-bold text-gray-800">React</span>
    </HighlightedTextIcon>
    {' '}and
    <HighlightedTextIcon
      as="a"
      href="https://tailwindcss.com"
      className="mx-2"
      icon={<Icon icon={tailwindcssIcon} />}
    >
      <span className="font-bold text-gray-800">TailwindCSS</span>
    </HighlightedTextIcon>
    {' '}and
    <HighlightedTextIcon
      as="a"
      href="https://ui.shadcn.com/"
      className="mx-2"
      icon={<img src="/img/shadcn.svg" alt="ShadCN" className="w-5 h-5" />}
    >
      <span className="font-bold text-gray-800">ShadCN/UI</span>
    </HighlightedTextIcon>

    {'. '}I also have building web app experience with
    <HighlightedTextIcon as="a" href="https://nextjs.org/" className="mx-2" icon={<img src="/img/nextjs.svg" alt="Next.js" className="w-5 h-5" />}>
      <span className="font-bold text-gray-800">Next.js</span>
    </HighlightedTextIcon>. I've been working with these tools for about <span className="font-bold text-gray-800">2 years</span> now and I'm confident in building apps using them. I completed an internship as a web developer at
    
    <HighlightedTextIcon as="a" href="https://weabers.com/" className="mx-2" icon={<img src="/img/weabers.avif" alt="Weabers" className="w-5 h-5" />}>
      <span className="font-bold text-gray-800">Weabers</span> 
    </HighlightedTextIcon>{'. '} I'm also a <HighlightedTextIcon as='a' href="https://www.sports.com" className="mx-2" icon={<img src="/img/sports.svg" alt="sports" className="w-5 h-5" />}>
      <span className="font-bold text-gray-800">sports enthusiast</span> 
    </HighlightedTextIcon> and a <HighlightedTextIcon
      as='a'
      href="https://robocopplays.netlify.app/"
      className="mx-2"
      icon={<img src="/img/gamer.svg" alt="gamer" className="w-5 h-5" />}
    >
      <span className="font-bold text-gray-800">gamer boy</span> 
    </HighlightedTextIcon>.
  </>
);

const about: AboutSectionContentProps = {
  text: <Text />,
};

export default about;
